<script lang="ts" setup>
import type { LessonRoomGuideCategory } from '../../model/types/lesson-room/enums'

import { useLessonRoomStore } from '../../model/store'
import LessonRoomPopup from './LessonRoomPopup.vue'
import LessonRoomGuideCategories from './LessonRoomGuideCategories.vue'
import LessonRoomGuideManual from './LessonRoomGuideManual.vue'

defineOptions({
  name: 'LessonRoomGuidesPopup',
})

const lessonRoomStore = useLessonRoomStore()

const selectCategory = (category: LessonRoomGuideCategory): void => {
  lessonRoomStore.setGuideCategory(category)
}

const goBack = (): void => {
  lessonRoomStore.setGuideCategory(null)
}

const close = (): void => {
  lessonRoomStore.setGuideOpen(false)
  lessonRoomStore.setGuideCategory(null)
}
</script>

<template>
  <LessonRoomPopup
    title="How to join guide"
    :can-back="!!lessonRoomStore.getGuideCategory"
    @back="goBack"
    @close="close"
  >
    <div class="lesson-room-guides">
      <LessonRoomGuideManual
        v-if="lessonRoomStore.getGuideCategory"
        :category="lessonRoomStore.getGuideCategory"
      />
      <LessonRoomGuideCategories
        v-else
        @click:category="selectCategory"
      />
    </div>
  </LessonRoomPopup>
</template>

<style scoped lang="scss" src="./LessonRoomGuidesPopup.scss" />